import * as types from '../actionType'

const initialState = []

const bannerShow = (state = initialState, action) => {
    switch (action.type) {
        case types.LIST_BANNER:
            return action.payload
        default:
            return state
    }
}

export default bannerShow;